export function isMatchedEntity(
  externalLocationId: string,
  externalLocationCode: string,
) {
  return Boolean(externalLocationId) && Boolean(externalLocationCode)
}
